import { apiFetch } from "./apiFetch";

export function fetchVisions() {
  return apiFetch("/visions/");
}

export function createVision(payload) {
  return apiFetch("/visions/", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export function updateVision(visionId, data) {
  return apiFetch(`/visions/${visionId}/`, {
    method: "PATCH",
    body: JSON.stringify(data),
  });
}

export function deleteVision(visionId) {
  return apiFetch(`/visions/${visionId}/`, {
    method: "DELETE",
  });
}

export function chooseVisionCompanion(visionId, companionType) {
  return apiFetch(`/visions/${visionId}/choose-companion/`, {
    method: "POST",
    body: JSON.stringify({
      companion_type: companionType,
    }),
  });
}